<template>
  <div>

    <div v-if="!loaded">
      <div class="content user-profile">
        <div class="container">
          <div class="loading-spinner">
            <div class="loading-spinner-image"></div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="loaded">
      <user-menu v-if="!editMode"
                 :menu-items="sections"
                 :activeItemId="activeSectionId"
                 :user="user"
                 @select="selectMenuItem"
                 :wordings="wordings"
                 :store="store"
                 :primary-lang="primaryLang"
                 :editMode="editMode" />

      <div class="content user-profile">
        <div class="container">

          <form method="post"
                action="#"
                class="form form--user-profile">
            <header-logo :logo-url="globalLogoUrl" />
            <h1 v-word="'layout.userProfile.header'"></h1>
            <div class="form__section"
                 v-word="'layout.userProfile.header.text'"></div>

            <accordion :ref="'section_credentials'"
                       @toggle="onSectionToggle"
                       :fixopen="openall">
              <template slot="title">
                <span v-word="'layout.userProfile.credentials.title'" />
              </template>

              <form method="post"
                    class="form form--user-profile">
                <input-password class="form__input--password"
                                label-word="layout.userProfile.credentials.password.label"
                                hint-word="layout.userProfile.credentials.password.hint"
                                :wordings-editable="wordingsEditable"
                                :wordings="wordings"
                                :wordings-meta="wordingsMeta"
                                :data="formData.password"
                                @change="inputChanged"
                                @wordingChange="onWordingChange"
                                @wordingCommand="runWordingCommand"
                                @error="$refs['section_credentials'].open()"
                                :enablePlaceholder="!openall" />

                <input-password class="form__input--password"
                                label-word="layout.userProfile.credentials.passwordConfirm.label"
                                hint-word="layout.userProfile.credentials.passwordConfirm.hint"
                                :wordings-editable="wordingsEditable"
                                :wordings="wordings"
                                :wordings-meta="wordingsMeta"
                                :data="formData.password_repeat"
                                @change="inputChanged"
                                @wordingChange="onWordingChange"
                                @wordingCommand="runWordingCommand"
                                @error="$refs['section_credentials'].open()"
                                :enablePlaceholder="!openall" />

                <div class="form__input form__input--submit form__input--submit--savePassword">
                  <button type="submit"
                          @click.prevent="submitChangePassword"
                          v-word:layout.userProfile.credentials.button.save></button>
                </div>

                <div class="form__input form__input--submit form__input--submit--deleteProfile">
                  <button type="submit"
                          @click.prevent="$refs['delete_profile_modal'].open();"
                          v-word:layout.userProfile.deleteProfile></button>
                </div>
              </form>

            </accordion>

            <accordion :ref="'section_personal'"
                       @toggle="onSectionToggle"
                       :fixopen="openall">
              <template slot="title">
                <span v-word="'layout.userProfile.personal.title'" />
              </template>

              <input-radio :data="formData.salutation"
                           :wordings="wordings"
                           :label-word="'layout.userProfile.personal.salutation'"
                           :wordings-editable="wordingsEditable"
                           :wordings-meta="wordingsMeta"
                           @change="inputChanged"
                           @wordingChange="onWordingChange"
                           @wordingCommand="runWordingCommand"
                           @error="$refs['section_personal'].open()"
                           :opts="[{
                            titleWord: 'layout.userProfile.personal.mr',
                            val: 'Herr'
                          }, {
                            titleWord: 'layout.userProfile.personal.mrs',
                            val: 'Frau'
                          }]" />

              <input-text label-word="layout.userProfile.personal.title.label"
                          hint-word="layout.userProfile.personal.title.hint"
                          :wordings-editable="wordingsEditable"
                          :wordings="wordings"
                          :wordings-meta="wordingsMeta"
                          :data="formData.title"
                          @change="inputChanged"
                          @wordingChange="onWordingChange"
                          @wordingCommand="runWordingCommand"
                          @error="$refs['section_personal'].open()"
                          :enablePlaceholder="!openall" />

              <input-text label-word="layout.userProfile.personal.name.label"
                          hint-word="layout.userProfile.personal.name.hint"
                          :wordings-editable="wordingsEditable"
                          :wordings="wordings"
                          :wordings-meta="wordingsMeta"
                          :data="formData.firstname"
                          @change="inputChanged"
                          @wordingChange="onWordingChange"
                          @wordingCommand="runWordingCommand"
                          @error="$refs['section_personal'].open()"
                          :enablePlaceholder="!openall" />

              <input-text label-word="layout.userProfile.personal.surname.label"
                          hint-word="layout.userProfile.personal.surname.hint"
                          :wordings-editable="wordingsEditable"
                          :wordings="wordings"
                          :wordings-meta="wordingsMeta"
                          :data="formData.surname"
                          @change="inputChanged"
                          @wordingChange="onWordingChange"
                          @wordingCommand="runWordingCommand"
                          @error="$refs['section_personal'].open()"
                          :enablePlaceholder="!openall" />

            </accordion>

            <accordion :ref="'section_job'"
                       @toggle="onSectionToggle"
                       :fixopen="openall">
              <template slot="title">
                <span v-word="'layout.userProfile.job.title'" />
              </template>

              <div class="form__input form__input--checkbox">
                <div class="form__input__wrap">
                  <label></label>
                  <input v-model="formData.is_freelancer.val"
                         id="check"
                         type="checkbox"
                         checked="">
                  <label for="check"
                         v-word:layout.userProfile.job.freelancer />
                </div>
              </div>

              <input-text label-word="layout.userProfile.job.publication.label"
                          hint-word="layout.userProfile.job.publication.hint"
                          :wordings-editable="wordingsEditable"
                          :wordings="wordings"
                          :wordings-meta="wordingsMeta"
                          :data="formData.publication"
                          @change="inputChanged"
                          @wordingChange="onWordingChange"
                          @wordingCommand="runWordingCommand"
                          @error="$refs['section_job'].open()"
                          :enablePlaceholder="!openall" />

              <input-text label-word="layout.userProfile.job.company.label"
                          hint-word="layout.userProfile.job.company.hint"
                          :wordings-editable="wordingsEditable"
                          :wordings="wordings"
                          :wordings-meta="wordingsMeta"
                          :data="formData.company"
                          @change="inputChanged"
                          v-bind:class="{ 'form__input--disabled': formData.is_freelancer.val }"
                          @wordingChange="onWordingChange"
                          @wordingCommand="runWordingCommand"
                          @error="$refs['section_job'].open()"
                          :enablePlaceholder="!openall" />

              <input-text label-word="layout.userProfile.job.department.label"
                          hint-word="layout.userProfile.job.department.hint"
                          :wordings-editable="wordingsEditable"
                          :wordings="wordings"
                          :wordings-meta="wordingsMeta"
                          :data="formData.department"
                          @change="inputChanged"
                          v-bind:class="{ 'form__input--disabled': formData.is_freelancer.val }"
                          @wordingChange="onWordingChange"
                          @wordingCommand="runWordingCommand"
                          @error="$refs['section_job'].open()"
                          :enablePlaceholder="!openall" />

              <input-text label-word="layout.userProfile.job.position.label"
                          hint-word="layout.userProfile.job.position.hint"
                          :wordings-editable="wordingsEditable"
                          :wordings="wordings"
                          :wordings-meta="wordingsMeta"
                          :data="formData.position"
                          @change="inputChanged"
                          v-bind:class="{ 'form__input--disabled': formData.is_freelancer.val }"
                          @wordingChange="onWordingChange"
                          @wordingCommand="runWordingCommand"
                          @error="$refs['section_job'].open()"
                          :enablePlaceholder="!openall" />

              <div class="form__input form__input--checkbox">
                <div class="form__input__wrap">
                  <label v-word:layout.userProfile.job.contactType></label>
                  <input v-model="formData.address_type.val"
                         id="Adresse"
                         name="contactType"
                         value="address"
                         type="radio">
                  <label for="Adresse"
                         v-word:layout.userProfile.job.contactType.address />
                  <input v-model="formData.address_type.val"
                         id="Postfach"
                         name="contactType"
                         value="postbox"
                         type="radio">
                  <label for="Postfach"
                         v-word:layout.userProfile.job.contactType.postbox />
                </div>
              </div>

              <input-text v-show="openall || formData.address_type.val == 'address'"
                          label-word="layout.userProfile.contact.street.label"
                          hint-word="layout.userProfile.contact.street.hint"
                          :wordings-editable="wordingsEditable"
                          :wordings="wordings"
                          :wordings-meta="wordingsMeta"
                          :data="formData.address"
                          @change="inputChanged"
                          @wordingChange="onWordingChange"
                          @wordingCommand="runWordingCommand"
                          @error="$refs['section_job'].open()"
                          :enablePlaceholder="!openall" />

              <input-text v-show="openall || formData.address_type.val == 'postbox'"
                          label-word="layout.userProfile.contact.postbox.label"
                          hint-word="layout.userProfile.contact.postbox.hint"
                          :wordings-editable="wordingsEditable"
                          :wordings="wordings"
                          :wordings-meta="wordingsMeta"
                          :data="formData.post_box"
                          @change="inputChanged"
                          @wordingChange="onWordingChange"
                          @wordingCommand="runWordingCommand"
                          @error="$refs['section_job'].open()"
                          :enablePlaceholder="!openall" />

              <input-text label-word="layout.userProfile.contact.address.label"
                          hint-word="layout.userProfile.contact.address.hint"
                          :wordings-editable="wordingsEditable"
                          :wordings="wordings"
                          :wordings-meta="wordingsMeta"
                          :data="formData.zip"
                          @change="inputChanged"
                          @wordingChange="onWordingChange"
                          @wordingCommand="runWordingCommand"
                          @error="$refs['section_job'].open()"
                          :enablePlaceholder="!openall" />

              <input-text label-word="layout.userProfile.contact.city.label"
                          hint-word="layout.userProfile.contact.city.hint"
                          :wordings-editable="wordingsEditable"
                          :wordings="wordings"
                          :wordings-meta="wordingsMeta"
                          :data="formData.city"
                          @change="inputChanged"
                          @wordingChange="onWordingChange"
                          @wordingCommand="runWordingCommand"
                          @error="$refs['section_job'].open()"
                          :enablePlaceholder="!openall" />

              <country-select label-word="layout.userProfile.contact.country.label"
                              :wordings-editable="wordingsEditable"
                              :wordings="wordings"
                              :wordings-meta="wordingsMeta"
                              :data="formData.country"
                              @change="inputChanged"
                              @wordingChange="onWordingChange"
                              @wordingCommand="runWordingCommand"
                              @error="$refs['section_job'].open()" />

              <input-text label-word="layout.userProfile.contact.phone.label"
                          hint-word="layout.userProfile.contact.phone.hint"
                          :wordings-editable="wordingsEditable"
                          :wordings="wordings"
                          :wordings-meta="wordingsMeta"
                          :data="formData.phone"
                          @change="inputChanged"
                          @wordingChange="onWordingChange"
                          @wordingCommand="runWordingCommand"
                          @error="$refs['section_job'].open()"
                          :enablePlaceholder="!openall" />

              <input-text label-word="layout.userProfile.contact.mobilePhone.label"
                          hint-word="layout.userProfile.contact.mobilePhone.hint"
                          :wordings-editable="wordingsEditable"
                          :wordings="wordings"
                          :wordings-meta="wordingsMeta"
                          :data="formData.mobile_phone"
                          @change="inputChanged"
                          @wordingChange="onWordingChange"
                          @wordingCommand="runWordingCommand"
                          @error="$refs['section_job'].open()"
                          :enablePlaceholder="!openall" />

            </accordion>

            <accordion :ref="'section_social'"
                       @toggle="onSectionToggle"
                       :fixopen="openall">
              <template slot="title">
                <span v-word="'layout.userProfile.webAndSocial.title'" />
              </template>

              <input-text label-word="layout.userProfile.webAndSocial.social_web.label"
                          hint-word="layout.userProfile.webAndSocial.social_web.hint"
                          :wordings-editable="wordingsEditable"
                          :wordings="wordings"
                          :wordings-meta="wordingsMeta"
                          :data="formData.social_web"
                          @change="inputChanged"
                          @wordingChange="onWordingChange"
                          @wordingCommand="runWordingCommand"
                          @error="$refs['section_social'].open()"
                          :enablePlaceholder="!openall" />

              <input-text label-word="layout.userProfile.webAndSocial.social_xing.label"
                          hint-word="layout.userProfile.webAndSocial.social_xing.hint"
                          :wordings-editable="wordingsEditable"
                          :wordings="wordings"
                          :wordings-meta="wordingsMeta"
                          :data="formData.social_xing"
                          @change="inputChanged"
                          @wordingChange="onWordingChange"
                          @wordingCommand="runWordingCommand"
                          @error="$refs['section_social'].open()"
                          :enablePlaceholder="!openall" />

              <input-text label-word="layout.userProfile.webAndSocial.social_linkedin.label"
                          hint-word="layout.userProfile.webAndSocial.social_linkedin.hint"
                          :wordings-editable="wordingsEditable"
                          :wordings="wordings"
                          :wordings-meta="wordingsMeta"
                          :data="formData.social_linkedin"
                          @change="inputChanged"
                          @wordingChange="onWordingChange"
                          @wordingCommand="runWordingCommand"
                          @error="$refs['section_social'].open()"
                          :enablePlaceholder="!openall" />

              <input-text label-word="layout.userProfile.webAndSocial.social_facebook.label"
                          hint-word="layout.userProfile.webAndSocial.social_facebook.hint"
                          :wordings-editable="wordingsEditable"
                          :wordings="wordings"
                          :wordings-meta="wordingsMeta"
                          :data="formData.social_facebook"
                          @change="inputChanged"
                          @wordingChange="onWordingChange"
                          @wordingCommand="runWordingCommand"
                          @error="$refs['section_social'].open()"
                          :enablePlaceholder="!openall" />

              <input-text label-word="layout.userProfile.webAndSocial.social_twitter.label"
                          hint-word="layout.userProfile.webAndSocial.social_twitter.hint"
                          :wordings-editable="wordingsEditable"
                          :wordings="wordings"
                          :wordings-meta="wordingsMeta"
                          :data="formData.social_twitter"
                          @change="inputChanged"
                          @wordingChange="onWordingChange"
                          @wordingCommand="runWordingCommand"
                          @error="$refs['section_social'].open()"
                          :enablePlaceholder="!openall" />

              <input-text label-word="layout.userProfile.webAndSocial.social_instagram.label"
                          hint-word="layout.userProfile.webAndSocial.social_instagram.hint"
                          :wordings-editable="wordingsEditable"
                          :wordings="wordings"
                          :wordings-meta="wordingsMeta"
                          :data="formData.social_instagram"
                          @change="inputChanged"
                          @wordingChange="onWordingChange"
                          @wordingCommand="runWordingCommand"
                          @error="$refs['section_social'].open()"
                          :enablePlaceholder="!openall" />
            </accordion>

            <accordion :ref="'section_interests'"
                       @toggle="onSectionToggle"
                       :fixopen="openall">
              <template slot="title">
                <span v-word="'layout.userProfile.interests.title'" />
              </template>

              <div class="form__section__wrap">
                <div class="form__section--left">

                  <input-checkbox-group :wordings-editable="wordingsEditable"
                                        :wordings="wordings"
                                        :wordings-meta="wordingsMeta"
                                        :data="formData.activity_journalist"
                                        :header-word="'layout.userProfile.interests.journalist'"
                                        :valDef="{
                                            'tv': 'layout.userProfile.interests.journalist.tv.label',
                                            'print': 'layout.userProfile.interests.journalist.print.label',
                                            'radio': 'layout.userProfile.interests.journalist.radio.label',
                                            'online': 'layout.userProfile.interests.journalist.online.label',
                                            'foto': 'layout.userProfile.interests.journalist.photo.label',
                                            'sonstige': 'layout.userProfile.interests.journalist.other.label',
                                          }"
                                        @change="inputChanged"
                                        @wordingChange="onWordingChange"
                                        @wordingCommand="runWordingCommand"
                                        @error="$refs['section_interests'].open()" />
                </div>
                <div class="form__section--right">
                  <input-checkbox-group :wordings-editable="wordingsEditable"
                                        :wordings="wordings"
                                        :wordings-meta="wordingsMeta"
                                        :data="formData.activity_blogger"
                                        :header-word="'layout.userProfile.interests.blogger'"
                                        :valDef="{
                                            'lifestyle-themen': 'layout.userProfile.interests.blogger.lifestyle.label',
                                            'food-themen': 'layout.userProfile.interests.blogger.food.label',
                                            'sport-themen': 'layout.userProfile.interests.blogger.sport.label',
                                            'musik-themen': 'layout.userProfile.interests.blogger.music.label',
                                            'sonstige': 'layout.userProfile.interests.blogger.other.label',
                                          }"
                                        @change="inputChanged"
                                        @wordingChange="onWordingChange"
                                        @wordingCommand="runWordingCommand"
                                        @error="$refs['section_interests'].open()" />

                  <input-checkbox-group :wordings-editable="wordingsEditable"
                                        :wordings="wordings"
                                        :wordings-meta="wordingsMeta"
                                        :data="formData.activity_other"
                                        :valDef="{
                                          'other': 'layout.userProfile.interests.others',
                                        }"
                                        @change="inputChanged"
                                        @wordingChange="onWordingChange"
                                        @wordingCommand="runWordingCommand"
                                        @error="$refs['section_interests'].open()" />
                </div>
              </div>
            </accordion>

            <accordion ref="mailing_preferences"
                       @toggle="onSectionToggle"
                       :fixopen="openall">

              <template slot="title">
                <span v-word="'layout.userProfile.mailing.header'" />
              </template>

              <h2 id="mailing_preferences_english_header"
                  v-word:layout.userProfile.mailing.english.header
                  v-if="mailingListsEnglish.length > 1 || showAll"
              ></h2>
              <mailing-lists class="mailing-lists-english"
                             :mailingLists="mailingListsEnglish"
                             :data="userMailingLists"
                             ref="mailing_preferences_english"
                             @change="handleMailingListChange" />

              <h2 id="mailing_preferences_german_header"
                  v-word:layout.userProfile.mailing.german.header
                  v-if="mailingListsGerman.length > 1  || showAll"
              ></h2>
              <mailing-lists class="mailing-lists-german"
                             :mailingLists="mailingListsGerman"
                             :data="userMailingLists"
                             ref="mailing_preferences_german"
                             @change="handleMailingListChange" />

              <div class="form__input form__input--submit">
                <button class="partial"
                        type="submit"
                        @click.prevent="unsubscribeAll"
                        v-word:layout.userProfile.mailing.unsubAll.button></button>
              </div>
            </accordion>

            <accordion :ref="'section_events'"
                       @toggle="onSectionToggle"
                       :fixopen="openall">
              <template slot="title">
                <span v-word="'layout.userProfile.events.title'" />
              </template>

              <input-split-checkbox-group :wordings-editable="wordingsEditable"
                                          :wordings="wordings"
                                          :wordings-meta="wordingsMeta"
                                          :data="formData.event_subscription"
                                          :valDef="{
                                            'press-conference': 'layout.userProfile.events.option.pressConference',
                                            'sport': 'layout.userProfile.events.option.sport',
                                            'setvisits': 'layout.userProfile.events.option.setvisits',
                                            ':split:': '',
                                            'premiers': 'layout.userProfile.events.option.premiers',
                                            'fototermines': 'layout.userProfile.events.option.fototermines',
                                            'branchen-events': 'layout.userProfile.events.option.branchenEvents',
                                          }"
                                          @change="inputChanged"
                                          @wordingChange="onWordingChange"
                                          @wordingCommand="runWordingCommand"
                                          @error="$refs['section_events'].open()" />

            </accordion>

            <accordion :ref="'section_contact'"
                       @toggle="onSectionToggle"
                       :fixopen="openall">
              <template slot="title">
                <span v-word="'layout.userProfile.contactVia.title'" />
              </template>

              <div class="form__section__wrap">
                <div class="form__section--left">
                  <input-checkbox label-word="layout.userProfile.contactVia.phone.label"
                                  :wordings-editable="wordingsEditable"
                                  :wordings="wordings"
                                  :wordings-meta="wordingsMeta"
                                  @wordingChange="onWordingChange"
                                  @wordingCommand="runWordingCommand"
                                  @error="$refs['section_contact'].open()"
                                  :data="formData.contact_via_phone"
                                  @change="inputChanged" />
                </div>
                <div class="form__section--right">
                  <input-checkbox label-word="layout.userProfile.contactVia.post.label"
                                  :wordings-editable="wordingsEditable"
                                  :wordings="wordings"
                                  :wordings-meta="wordingsMeta"
                                  @wordingChange="onWordingChange"
                                  @wordingCommand="runWordingCommand"
                                  @error="$refs['section_contact'].open()"
                                  :data="formData.contact_via_address"
                                  @change="inputChanged" />
                </div>
              </div>
            </accordion>

            <section class="form__section user-profile-submit">
              <div class="form__input form__input--submit">
                <button type="submit"
                        @click.prevent="submit"
                        v-word="'layout.userProfile.submit.button'"></button>
              </div>

              <div class="form__section__links">
                <br>
                <a class=""
                   v-show="returnUrl || editMode"
                   :href="!editMode && returnUrl"
                   v-word:layout.userProfile.mailing.backToPortal />
              </div>
            </section>
          </form>
        </div>
      </div>
      <unsubscribe-modal ref="unsubscribe_modal"
                         @loading="$emit('loading')"
                         @loaded="$emit('loaded')"
                         :store="store"
                         @unsubscribe="handleAllUnsubscribe"
                         :wordings-editable="wordingsEditable"
                         :wordings="wordings"
                         :wordings-meta="wordingsMeta"
                         @wordingChange="onWordingChange"
                         @wordingCommand="runWordingCommand"
                         @open="$emit('refreshTooltips')"
                         :wordingsOverride="wordingsOverride" />

      <delete-profile-modal ref="delete_profile_modal"
                            @loading="$emit('loading')"
                            @loaded="$emit('loaded')"
                            :store="store"
                            @profileDeleted="$router.push({ path: 'profile-deleted' })"
                            :wordings-editable="wordingsEditable"
                            :wordings="wordings"
                            :wordings-meta="wordingsMeta"
                            @wordingChange="onWordingChange"
                            @wordingCommand="runWordingCommand"
                            @open="$emit('refreshTooltips')"
                            :wordingsOverride="wordingsOverride" />
    </div>
  </div>
</template>

<script>
import config from 'config';
import $ from 'jquery';
import userMenu from './user-profile/UserMenu';
import accordion from './user-profile/FormSection';
import formDataDef from './user-profile/form-data';
import * as mixins from '../mixins';
import mailingLists from '../components/MailingLists';
import instanceConfig from '../utils/instanceConfig';
import wordings from '../utils/wordings';
import CountrySelect from '../components/CountrySelect';
import unsubscribeModal from './user-profile/UnsubscribeModal';
import deleteProfileModal from './user-profile/DeleteProfileModal';
import backendConfig from './../utils/backendConfig';

export default {
  props: ['store', 'openall', 'editMode', 'showAll'],
  mixins: [mixins.form, mixins.wordedPage, mixins.pageWithLogo],
  data() {
    return {
      activeSectionId: '',
      refMap: [],
      formDataDef,
      formStorageName: false,
      userMailingLists: [],
      mailingListTree: [],
      user: { name: '', surname: '' },
      returnUrl: null,
      primaryLang: null,
      loaded: false,
    };
  },
  created() {
    !this.editMode &&
      this.fetchMailingLists()
        .then(mailingListTree => {
          this.mailingListTree = mailingListTree;

          for (const mailingPortal of this.mailingListTree) {
            mailingPortal.ref = 'section_ml_' + mailingPortal.id;
          }

          this.fetchUserData();
        })
        .catch(() => {
          this.fetchUserData();
        });

    !this.editMode &&
      instanceConfig
        .get()
        .then(config => {
          this.returnUrl = config['return-url'];
          this.primaryLang = config['primary-lang'];
        })
        .catch(() => {});
  },
  methods: {
    backToPortal() {
      if (this.returnUrl) {
        window.location = this.returnUrl;
      }
    },
    fetchMailingLists() {
      return backendConfig.get().then(({backendUrl}) => {
        return this.$http
          .get(
            backendUrl + config.backend.feeds.mailingListsAll +
              '?sso=' +
              this.store.brokerData,
          )
          .then(resp => {
            const mailingLists = resp.body;
            const filteredMailingLists = [];

            for (const portal of mailingLists) {
              if (!portal.mailing_tree) {
                continue;
              }
              filteredMailingLists.push(portal);
              portal.mailing_tree.sort((a, b) => a.order - b.order);
              for (const firstLevel of portal.mailing_tree) {
                if (!firstLevel.children) {
                  continue;
                }
                firstLevel.children.sort((a, b) => a.order - b.order);
              }
            }
            return filteredMailingLists;
          });
        });
    },
    fetchUserData() {
      if (!this.store.brokerData) {
        return Promise.reject();
      }

      return backendConfig.get().then(({backendUrl}) => {
        return this.$http
          .get(backendUrl + config.backend.feeds.userProfile + '?sso=' + this.store.brokerData)
          .then(function(resp) {
            delete resp.body.password;
            this.user.name = resp.body.firstname;
            this.user.surname = resp.body.surname;
            this.populateForm(resp.body);
            this.userMailingLists = resp.body.mailinglists;

            this.loaded = true;
          })
          .catch(response => {
            if (response.status === 401) {
              if (!config.development.userProfile.requireLogin) {
                this.loaded = true;
                return;
              }
              this.$router.push({
                name: 'login-back',
                params: { back: 'user-profile' },
              });
            }

            this.loaded = true;
          });
        });
    },
    handleMailingListChange(change) {
      if (change.id) {
        if (change.value) {
          if (!this.userMailingLists.includes(change.id)) {
            this.userMailingLists.push(change.id);
          }
        } else {
          const index = this.userMailingLists.indexOf(change.id);
          if (index !== -1) {
            this.userMailingLists.splice(index, 1);
          }
        }
      }
    },
    selectMenuItem(id) {
      let section;
      let subsection;
      if (id.startsWith('section_ml_')) {
        section = this.$refs['mailing_preferences'];
        switch (id) {
          case 'section_ml_english':
            subsection = $('#mailing_preferences_english_header')[0];
            break;
          case 'section_ml_german':
            subsection = $('#mailing_preferences_german_header')[0];
            break;
        }
      } else {
        section = this.$refs[id];
      }

      if (section) {
        if (subsection) {
          section.open(() => {
            $('html, body').animate(
              { scrollTop: $(subsection).offset().top },
              200,
            );
          });
        } else {
          $('html, body').animate(
            { scrollTop: $(section.$el).offset().top },
            200,
          );
          section.open();
        }
      }
    },
    computeRefMap() {
      // TODO fix this
      return;
      const allIds = Object.keys(this.$refs);
      allIds.filter(id => id.startsWith('section_'));
      this.refMap = [];

      for (const sectionId of allIds) {
        const ref = this.$refs[sectionId];

        if (!ref) {
          continue;
        }

        this.refMap.push({
          id: sectionId,
          offsetY: $(ref.$el).offset().top,
        });
      }

      this.refMap.sort((a, b) => a.offsetY - b.offsetY);
    },
    computeCurrentSection() {
      const currentPos = window.scrollY;
      for (const ref of this.refMap) {
        if (currentPos > ref.offsetY - 20) {
          this.activeSectionId = ref.id;
        }
      }
    },
    onSectionToggle() {
      this.computeRefMap();
      this.computeCurrentSection();
    },
    submit() {
      let requestData = this.marshalFormValues();
      requestData.mailinglists = this.userMailingLists;
      requestData.sso = this.store.brokerData;

      this.resetFormErrors();
      this.hasErrors = false;

      this.$emit('loading');
      backendConfig.get().then(({backendUrl}) => {
        this.$http
          .put(backendUrl + config.backend.feeds.userProfile, requestData)
          .then(function(resp) {
            this.user.name = requestData.firstname;
            this.user.surname = requestData.surname;
            this.$emit('loaded');
            this.flash(this.wordings['layout.userProfile.success'], 'success');
          })
          .catch(function(resp) {
            if (resp.body.errors) {
              this.hasErrors = this.showFormErrors(resp.body.errors);
            }
            this.$emit('loaded');
            if (resp.status >= 500) {
              this.flash(
                this.wordings['flashes.generalError'],
                'error',
              );
            } else {
              this.flash(
                this.wordings['layout.userProfile.errors.invalidForm'],
                'error',
              );
            }
          });
        });
      // Edge has some problem with finally
      // .finally(() => {
      //   this.$emit('loaded');
      // });
    },
    submitChangePassword() {
      const formData = this.marshalFormValues();
      this.resetFormErrors();

      if (formData.password_repeat !== formData.password) {
        this.showFormErrors({
          password_repeat: { rule: 'passwordRepeatMatch' },
        });
        return;
      }

      let requestData = { password: formData.password };

      backendConfig.get().then(({backendUrl}) => {
        const url =
          backendUrl + config.backend.feeds.passwordChange + '?sso=' + this.store.brokerData;

        this.$emit('loading');
        this.$http
          .put(url, requestData)
          .then(function(resp) {
            this.formData.password.val = '';
            this.formData.password_repeat.val = '';
            this.flash(
              this.wordings['layout.userProfile.credentials.password.success'],
              'success',
            );
            this.$emit('loaded');
          })
          .catch(function(resp) {
            if (resp.status === 400 && resp.body.errors) {
              this.hasErrors = this.showFormErrors(resp.body.errors);
            } else if (resp.status >= 500) {
              this.serverError = true;
              this.flash(
                this.wordings['flashes.generalError'],
                'error',
              );
            }
            this.$emit('loaded');
          });
        // Edge has some problem with finally
        // .finally(() => {
        //   this.$emit('loaded');
        // });
        });
    },
    unsubscribeAll() {
      this.$refs['unsubscribe_modal'].open();
    },
    handleAllUnsubscribe() {
      for (var i = this.userMailingLists.length; i > 0; i--) {
        this.userMailingLists.pop();
      }
    },
    reorderMailingLists() {
      const en = this.$refs['mailing_preferences_english'].$el;
      const de = this.$refs['mailing_preferences_german'].$el;
      const deHeader = $('#mailing_preferences_german_header');
      const enHeader = $('#mailing_preferences_english_header');

      switch (this.primaryLang) {
        case 'de':
          $(de).after(en);
          break;
        case 'en':
          $(en).after(de);
          break;
      }

      $(deHeader).insertBefore(de);
      $(enHeader).insertBefore(en);
    },
  },
  computed: {
    sections() {
      const personalDataSections = [
        {
          id: 'section_credentials',
          titleWord: 'layout.userProfile.credentials.title',
        },
        {
          id: 'section_personal',
          titleWord: 'layout.userProfile.personal.title',
        },
        { id: 'section_job', titleWord: 'layout.userProfile.job.title' },
        {
          id: 'section_social',
          titleWord: 'layout.userProfile.webAndSocial.title',
        },
        {
          id: 'section_interests',
          titleWord: 'layout.userProfile.interests.title',
        },
        {
          id: 'mailing_preferences',
          titleWord: 'layout.userProfile.mailing.header',
        },
        { id: 'section_events', titleWord: 'layout.userProfile.events.title' },
        {
          id: 'section_contact',
          titleWord: 'layout.userProfile.contactVia.title',
        },
      ];

      const mailingSections = [];
      for (const i in this.mailingListTree) {
        mailingSections.push({
          id: 'section_ml_' + i,
          title: this.mailingListTree[i].name,
        });
      }

      const sections = {
        personalData: personalDataSections,
        mailingLists: mailingSections,
      };

      return sections;
    },
    mailingListsEnglish() {
      const portal = this.mailingListTree.find(
        portal => portal.id === 'english',
      );
      return portal ? portal.mailing_tree : [];
    },
    mailingListsGerman() {
      const portal = this.mailingListTree.find(
        portal => portal.id === 'german',
      );
      return portal ? portal.mailing_tree : [];
    },
  },
  mounted() {
    this.$emit('loaded');

    this.computeRefMap();

    $(window).on('scroll', evt => {
      this.computeCurrentSection();
    });

    this.reorderMailingLists();
  },
  watch: {
    primaryLang() {
      this.reorderMailingLists();
    },
  },
  components: {
    userMenu,
    accordion,
    mailingLists,
    CountrySelect,
    unsubscribeModal,
    deleteProfileModal,
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/UserProfile.vue